import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PasswordEmailEntry from './ForgetPassword/PasswordEmailEntry';
import UsernameEmailEntry from './ForgetUsername/UsernameEmailEntry';
import PasswordResetEntry from './ForgetPassword/PasswordResetEntry';
import  Footer  from '../shared/Footer.js';

export function LoginRecovery() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Routes>
        <Route path="forgetPassword" element={<PasswordEmailEntry />} />
        <Route path="forgetUsername" element={<UsernameEmailEntry />} />
        <Route path="resetPassword" element={<PasswordResetEntry />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default LoginRecovery;
